// Obtener la URL actual
var currentUrl = window.location.href;

// Seleccionar el elemento al que deseas agregar la clase
var element = document.querySelector('.header-wrapper');

// URLs que deben coincidir exactamente
var exactMatchUrls = [
  'https://morehumanshop.com/',
  'https://morehumanshop.com/en-us',
  'https://morehumanshop.com/es-us',
  'https://morehumanshop.com/en',
  'https://morehumanshop.com/es'
];

// Fragmento de URL para coincidencia parcial
var partialMatch = '/collections/';

// Verifica coincidencia exacta o parcial
if (exactMatchUrls.includes(currentUrl) || currentUrl.includes(partialMatch)) {
  element.classList.add('home-activo');
}

// Fragmento de URL para coincidencia parcial
var partialMatch = '/camilo-cifuentes';

// Verifica coincidencia exacta o parcial
if (exactMatchUrls.includes(currentUrl) || currentUrl.includes(partialMatch)) {
  element.classList.add('home-activo');
}

// Seleccionar el elemento al que deseas agregar la clase
var element = document.querySelector('.content-for-layout');

// URLs que deben coincidir exactamente
var exactMatchUrls = [
  'https://morehumanshop.com/en-us/collections/all',
  'https://morehumanshop.com/es-us/collections/all',
  'https://morehumanshop.com/es-us',
  'https://morehumanshop.com/en-us',
  'https://morehumanshop.com/en',
  'https://morehumanshop.com/es'
];

// Verifica coincidencia exacta o parcial
if (exactMatchUrls.includes(currentUrl) || currentUrl.includes(partialMatch)) {
  element.classList.add('home-shop_all');
}


// Seleccionar el elemento al que deseas agregar la clase
var element = document.querySelector('.breadcrumbs');

// URLs que deben coincidir exactamente
var exactMatchUrls = [
  'https://morehumanshop.com/en-us/collections/',
  'https://morehumanshop.com/es-us/collections/'
];

// Fragmento de URL para coincidencia parcial
var partialMatch = '/collections/';

// Verifica coincidencia exacta o parcial
if (exactMatchUrls.includes(currentUrl) || currentUrl.includes(partialMatch)) {
  element.classList.add('visible');
}

// Fragmento de URL para coincidencia parcial
var partialMatch = '/pages/';

// Verifica coincidencia exacta o parcial
if (exactMatchUrls.includes(currentUrl) || currentUrl.includes(partialMatch)) {
  element.classList.add('visible');
}

